<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">会員番号</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ member_no }}</div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">お名前カナ</label>
                    <div class="col-sm-4 birthDateMb1">
                        <input
                            id="currentNameKana"
                            type="text"
                            :class="{'is-invalid': valid.family_name_kana}"
                            class="form-control"
                            v-model="from_set_data.family_name_kana"
                            placeholder="カナ（姓）"
                        >
                        <div class="invalid-feedback" v-if="valid.family_name_kana">{{ valid_message.family_name_kana }}</div>
                    </div>
                    <div class="col-sm-4">
                        <input
                            id="urrentNameKana"
                            type="text"
                            :class="{'is-invalid': valid.given_name_kana}"
                            class="form-control"
                            v-model="from_set_data.given_name_kana"
                            placeholder="カナ（名）"
                        >
                        <div class="invalid-feedback" v-if="valid.given_name_kana">{{ valid_message.given_name_kana }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">お名前</label>
                    <div class="col-sm-4 birthDateMb1">
                        <input
                            id="currentName"
                            type="text"
                            :class="{'is-invalid': valid.family_name}"
                            class="form-control"
                            v-model="from_set_data.family_name"
                            placeholder="姓"
                        >
                        <div class="invalid-feedback" v-if="valid.family_name">{{ valid_message.family_name }}</div>
                    </div>
                    <div class="col-sm-4">
                        <input
                            id="currentName"
                            type="text"
                            :class="{'is-invalid': valid.given_name}"
                            class="form-control"
                            v-model="from_set_data.given_name"
                            placeholder="名"
                        >
                        <div class="invalid-feedback" v-if="valid.given_name">{{ valid_message.given_name }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">性別</label>
                    <div class="col-sm-4 align-self-center">
                        <div class="form-check">
                            <input
                                id="gridRadios1"
                                class="form-check-input"
                                type="radio"
                                :value="0"
                                v-model="from_set_data.gender"
                            />
                            <label class="form-check-label" for="gridRadios1">男性</label>
                        </div>
                    </div>
                    <div class="col-sm-4 align-self-center">
                        <div class="form-check">
                            <input
                                id="gridRadios2"
                                class="form-check-input"
                                type="radio"
                                :value="1"
                                v-model="from_set_data.gender"
                            />
                            <label class="form-check-label" for="gridRadios2">女性</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">生年月日</label>
                    <div class="col-12 col-sm-4 birthDateMb1">
                        <input
                            type="date"
                            v-model="from_set_data.birth_date"
                            class="form-control"
                            :class="{'is-invalid': valid.birth_date }"
                            >
                        <div class="invalid-feedback" v-if="valid.birth_date">{{ valid_message.birth_date }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">郵便番号</label>
                    <div class="col-12 col-sm-4 birthDateMb1">
                       <input
                            id="currentZipCode"
                            type="text"
                            :class="{'is-invalid': valid.zipcode}"
                            class="form-control"
                            v-model="from_set_data.zipcode"
                            placeholder="0000000"
                        >
                        <div class="invalid-feedback" v-if="valid.zipcode">{{ valid_message.zipcode }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">住所</label>
                    <div class="col-12 col-sm-8 birthDateMb1 mb-1">
                       <input
                            id="currentAddres"
                            type="text"
                            :class="{'is-invalid': valid.address1}"
                            class="form-control"
                            v-model="from_set_data.address1"
                            placeholder=""
                        >
                        <div class="invalid-feedback" v-if="valid.address1">{{ valid_message.address1 }}</div>
                    </div>
                    <label class="col-sm-3 col-form-label pcview"></label>
                    <div class="col-12 col-sm-8 birthDateMb1">
                       <input
                            id="currentAddres"
                            type="text"
                            :class="{'is-invalid': valid.address2}"
                            class="form-control"
                            v-model="from_set_data.address2"
                            placeholder=""
                        >
                        <div class="invalid-feedback" v-if="valid.address2">{{ valid_message.address2 }}</div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row justify-content-center flex-column flex-sm-row px-3">
                        <button
                            type="button"
                            class="btn btn-outline-info mb-2 col-md-btn-size"
                            @click="submitChangePassword"
                            :disabled="valid_status"
                            >変更する
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-secondary mb-2 ml-0 ml-sm-5 col-md-btn-size"
                            @click="gotoMypageInfo"
                            >戻る
                        </button>
                    </div>
                </div>
            </div>
            <ConfirmDialog
                v-if="confirmDialogSw === true"
                initialMessage=""
                doing=""
                notDoing=""
                :close="btnName"
                :processing="processing"
                @closeBtn="onSignupForm"
            />
        </Card>
    </div>
</template>

<script>
import { GET_MEMBER_ID } from '../../constants/signin.js';
import { GET_MEMBER, UPDATE_MEMBER_INFO } from '../../constants/mypage_info';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { memberStatusMixin } from './memberStatusMixin';
import Card from '../components/Card';
import MypageHeader from './MypageHeader';
import validater from '../../lib/validater';
import MypageSideMenu from './MypageSideMenu';
import ConfirmDialog from '../components/ConfirmDialog';
import { utilityMixin } from '../../mixins/utility';

export default {
    components: {
        MypageSideMenu,
        MypageHeader,
        validater,
        Card,
        ConfirmDialog
    },
    mixins: [
        utilityMixin,
        memberStatusMixin
    ],
    data () {
        return {
            page_title: '会員情報変更',
            member_no: null,
            full_name: null,
            submit_disabled: true,
            from_set_data: {
                member_no: '',
                family_name: '',
                family_name_kana: '',
                given_name: '',
                given_name_kana: '',
                zipcode: '',
                address1: '',
                address2: '',
                gender: 0,
                birth_date: ''
            },
            valid: {
                family_name: false,
                family_name_kana: false,
                given_name: false,
                given_name_kana: false,
                zipcode: false,
                address1: false,
                address2: false,
                gender: false,
                birth_date: false
            },
            valid_message: {
                family_name: '',
                family_name_kana: '',
                given_name: '',
                given_name_kana: '',
                zipcode: '',
                address1: '',
                address2: '',
                gender: 0,
                birth_date: ''
            },
            confirmDialogSw: false,
            // 処理の結果のオブジェクト
            processing: {
                result: '1',
                resultText: '会員情報の変更が完了しました。',
                btnDisabled: 0,
            },
            btnName: ''
        };
    },
    created () {
        this.initialize();
    },
    computed: {
        valid_status () {
            return Object.keys(this.valid).some((key) => {
                return this.valid[key];
            });
        }
    },
    watch: {
        'from_set_data.family_name' (val) {
            if (!val) {
                this.valid_message.family_name = this.$t("error.validation.required.familyName");
                this.valid.family_name = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 50)) {
                this.valid_message.family_name = this.$t("error.validation.length.familyName");
                this.valid.family_name = true;
                return;
            }
            this.valid_message.family_name = '';
            this.valid.family_name = false;
        },
        'from_set_data.given_name' (val) {
            if (!val) {
                this.valid_message.given_name = this.$t("error.validation.required.givenName");
                this.valid.given_name = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 50)) {
                this.valid_message.given_name = this.$t("error.validation.length.givenName");
                this.valid.given_name = true;
                return;
            }
            this.valid_message.given_name = '';
            this.valid.given_name = false;
        },
        'from_set_data.family_name_kana' (val) {
            if (!val) {
                this.valid_message.family_name_kana = this.$t("error.validation.required.familyNameKana");
                this.valid.family_name_kana = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 50)) {
                this.valid_message.family_name_kana = this.$t("error.validation.length.familyNameKana");
                this.valid.family_name_kana = true;
                return;
            } else if (!validater.checkZenHanKana(val)) {
                this.valid_message.family_name_kana = this.$t("error.validation.kataKana");
                this.valid.family_name_kana = true;
                return;
            }
            this.valid_message.family_name_kana = '';
            this.valid.family_name_kana = false;
        },
        'from_set_data.given_name_kana' (val) {
            if (!val) {
                this.valid_message.given_name_kana = this.$t("error.validation.required.givenNameKana");
                this.valid.given_name_kana = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 50)) {
                this.valid_message.given_name_kana = this.$t("error.validation.length.givenNameKana");
                this.valid.given_name_kana = true;
                return;
            } else if (!validater.checkZenHanKana(val)) {
                this.valid_message.given_name_kana = this.$t("error.validation.kataKana");
                this.valid.given_name_kana = true;
                return;
            }
            this.valid_message.given_name_kana = '';
            this.valid.given_name_kana = false;
        },
        'from_set_data.zipcode' (val) {
            if (!val) {
                this.valid_message.zipcode = this.$t("error.validation.required.zipcode");
                this.valid.zipcode = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 7)) {
                this.valid_message.zipcode = this.$t("error.validation.length.zipcode");
                this.valid.zipcode = true;
                return;
            } else if (!validater.checkStringLengthMin(val, 7)) {
                this.valid_message.zipcode = this.$t("error.validation.length.zipcode");
                this.valid.zipcode = true;
                return;
            } else if (!validater.checkNumber(val)) {
                this.valid_message.zipcode = this.$t("error.validation.length.zipcode");
                this.valid.zipcode = true;
                return;
            }
            this.valid_message.zipcode = '';
            this.valid.zipcode = false;
        },
        'from_set_data.address1' (val) {
            if (!val) {
                this.valid_message.address1 = this.$t("error.validation.required.address");
                this.valid.address1 = true;
                return;
            } else if (!validater.checkStringLengthMax(val, 50)) {
                this.valid_message.address1 = this.$t("error.validation.length.address");
                this.valid.address1 = true;
                return;
            }
            this.valid_message.address1 = '';
            this.valid.address1 = false;
        },
        'from_set_data.address2' (val) {
            if (val) {
                if (!validater.checkStringLengthMax(val, 50)) {
                    this.valid_message.address2 = this.$t("error.validation.length.address");
                    this.valid.address2 = true;
                    return;
                }
            }
            this.valid_message.address2 = '';
            this.valid.address2 = false;
        },
        'from_set_data.birth_date' (val) {
            console.log(this.checkTodaySmall(val));
            if (!this.checkTodaySmall(val)) {
                this.valid_message.birth_date = this.$t("error.validation.checkDate");
                this.valid.birth_date = true;
                return;
            }
            this.valid_message.birth_date = '';
            this.valid.birth_date = false;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            this.GetLoginUserMemberStatus();
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            this.setMember();
            if (process.env.MIX_APP_URL) {
                this.btnName = 'OK';
            } else {
                this.btnName = 'ログインページに戻る';
            }
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function () {
            this.from_set_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.from_set_data.family_name = this.$store.state.auth.loginMember.family_name;
            this.from_set_data.given_name = this.$store.state.auth.loginMember.given_name;
            this.from_set_data.family_name_kana = this.$store.state.auth.loginMember.family_name_kana;
            this.from_set_data.given_name_kana = this.$store.state.auth.loginMember.given_name_kana;
            this.from_set_data.zipcode = this.$store.state.auth.loginMember.zipcode;
            this.from_set_data.address1 = this.$store.state.auth.loginMember.address1;
            this.from_set_data.address2 = this.$store.state.auth.loginMember.address2;
            this.from_set_data.gender = this.$store.state.auth.loginMember.gender;
            this.from_set_data.birth_date = this.$store.state.auth.loginMember.birth_date;
        },
        /** ----------------------------------------------
         * パスワード変更ボタン押下時処理
         * ---------------------------------------------- */
        submitChangePassword: async function (event) {
            this.$store.commit("loading/setIsLoading", true);
            try {
                let res = await this.$apollo.mutate({
                    mutation: UPDATE_MEMBER_INFO,
                    variables: {
                        member_no: this.from_set_data.member_no,
                        family_name: this.from_set_data.family_name,
                        given_name: this.from_set_data.given_name,
                        family_name_kana: this.hankanaChangeZenkana(this.from_set_data.family_name_kana),
                        given_name_kana: this.hankanaChangeZenkana(this.from_set_data.given_name_kana),
                        zipcode: this.from_set_data.zipcode,
                        address1: this.from_set_data.address1,
                        address2: this.from_set_data.address2,
                        gender: this.from_set_data.gender,
                        birth_date: this.from_set_data.birth_date
                    }
                });

                if (res.data.memberUpdateInfo.result === 1) {
                    // this.logOut();
                    this.confirmDialogSw = true;
                    this.$store.commit("loading/setIsLoading", false);
                    // this.$router.push({ path: '/mypage-info-complete' });
                } else {
                    this.$store.commit("loading/setIsLoading", false);
                }
            } catch (error) {
                if (error.graphQLErrors[0].message == "The given data was invalid.") {
                    this.valid.newPassword = true;
                    this.valid_message.newPassword = this.$t("error.validation.passwordSame");
                } else {
                    this.valid.currentName = true;
                    this.valid_message.currentName = error.graphQLErrors[0].message;
                }
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /** ----------------------------------------------
         * 戻るボタンの処理 会員情報参照画面へ
         * ---------------------------------------------- */
        gotoMypageInfo: function () {
            this.$router.push({ path: '/mypage-info' });
        },
        /** ----------------------------------------------
         * ログアウト処理
         * ---------------------------------------------- */
        logOut: function () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        onSignupForm: function () {
            if (process.env.MIX_APP_URL) {
                // window.location.href = process.env.MIX_APP_URL;
                this.$router.push({ path: '/mypage' });
            } else {
                this.$router.push({ path: '/' });
            }
        }
    }
}

</script>

<style scoped>
@media screen and (max-width: 575px) {
    .mail-confirm-br {
        display: none;
    }
}
</style>
